module.exports = __webpack_public_path__ + "static/logo-3024792b5dcd80a2a2b0da2ec68ece64.png";